import { Pagination, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import loader from "../assets/images/loader.gif";
import dayjs from "dayjs";
import axiosClient from "../axios";
import SideBar from "./SideBar";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Pagination_2 from "./Pagination_2";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { dateConvert } from "../dateConverter";
import { eventCodeMap } from "../helperComponent/Constant";
import "../assets/css/AdminCommon.css";

const UserEventLogs = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [singleEvent, setSingleEvent] = useState(false);
  const [eventid, setEventId] = useState("");
  const [date, setDate] = useState({
    start: null,
    end: null,
  });
  const [singleEventdate, setSingleEventDate] = useState({
    start: null,
    end: null,
  });
  const [pagination, setPagination] = useState({
    page: 0,
    limit: 50,
  });
  const [detailsPagination, setDetailsPagination] = useState({
    page: 0,
    limit: 50,
  });

  const [nextButton, setNextButton] = useState(true);
  const [nextButton1, setNextButton1] = useState(true);
  const [eventDetails, setEventDetails] = useState([]);
  const [tableNumber, setTableNumber] = useState(1);

  const geUniqueEventLogs = async () => {
    let startDate = date?.start ? dateConvert(date?.start) : null;
    let endDate = date?.end ? dateConvert(date?.end) : null;

    if (startDate && endDate) {
      const diffInDays = dayjs(endDate).diff(dayjs(startDate), "day");

      if (diffInDays < 0) {
        alert("Start date cannot be greater than end date.");
        return;
      }

      if (diffInDays > 30) {
        alert("Date range can't be more than 30 days.");
        return;
      }
    }
    setTableNumber(1);

    setLoading(true);
    axiosClient
      .get(
        `/event-detials?s_date=${startDate}&e_date=${endDate}&page=${pagination.page}&limit=${pagination.limit}`
      )
      .then((res) => {
        setData(res?.data?.response);
        setNextButton1(res?.data?.response?.length >= pagination.limit);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  const getEventDetails = (data) => {
    const eventId = data?._id?.event_id || eventid;
    setEventId(eventId);
    setSingleEvent(true);

    let startDate = date?.start ? dateConvert(date?.start) : null;
    let endDate = date?.end ? dateConvert(date?.end) : null;

    setTableNumber(2);
    setLoading(true);

    if (startDate && endDate) {
      const diffInDays = dayjs(endDate).diff(dayjs(startDate), "day");
      if (diffInDays < 0) {
        alert("Start date cannot be greater than end date.");
        return;
      }
      if (diffInDays > 30) {
        alert("Date range can't be more than 30 days.");
        return;
      }
    }

    axiosClient
      .get(
        `/sengle-event-details?eventId=${eventId}&s_date=${startDate}&e_date=${endDate}&page=${detailsPagination.page}&limit=${detailsPagination.limit}`
      )
      .then((res) => {
        setEventDetails(res?.data?.response);
        setNextButton(res?.data?.response?.length >= detailsPagination.limit);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  const clearFilters = () => {
    setDate({ start: null, end: null });
    setSingleEventDate({ start: null, end: null });
    setPagination({ ...pagination, page: 0 });
    setEventDetails([]);
    setEventId('');
    setSingleEvent(false);
    setTableNumber(1);
  };

  useEffect(() => {
    if (eventid && tableNumber != 1) {
      getEventDetails(eventid);
    }
  }, [detailsPagination]);

  useEffect(() => {
    setSingleEvent(false);
    geUniqueEventLogs();
  }, [pagination]);

  return (
    <>
      <SideBar handleSideBar={true} activeTab={"eventLogs"} />
      <div className="admin-screen-v4">
        <div className="admin-header-v4">
          <h2>Daily Event Logs</h2>
          <div className="dFlex" style={{ gap: "16px" }}>
            {tableNumber === 2 && (
              <button
                className="btn-secondary-v4"
                onClick={() => {
                  setEventDetails([]);
                  setEventId('');
                  setSingleEvent(false);
                  setTableNumber(1);
                  setDetailsPagination({ page: 0, limit: 50 });
                }}
              >
                ← Back to Events
              </button>
            )}
          </div>
        </div>

        <div className="admin-form-container-v4" style={{ marginBottom: "24px" }}>
          <div className="form-section-v4">
            <h3 className="section-header-v4">
              {tableNumber === 1 ? "Event Statistics Filter" : "Event Details Filter"}
            </h3>
            <div className="form-row-v4">
              <div className="form-group-v4 date-picker-wrapper-v4">
                <label className="form-label-v4">Start Date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={date?.start}
                    onChange={(value) => setDate({ ...date, start: value })}
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </div>

              <div className="form-group-v4 date-picker-wrapper-v4">
                <label className="form-label-v4">End Date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={date?.end}
                    onChange={(value) => setDate({ ...date, end: value })}
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </div>

            <div className="button-group-v4">
              <button
                className="cancel-button-v4"
                onClick={clearFilters}
              >
                Clear Filters
              </button>
              <button
                className="submit-button-v4"
                onClick={tableNumber === 1 ? geUniqueEventLogs : () => getEventDetails()}
                disabled={!(date?.start && date?.end)}
              >
                {tableNumber === 1 ? "Get Event Stats" : "Get Event Details"}
              </button>
            </div>
          </div>
        </div>

        {!loading ? (
          <div className="admin-form-container-v4">
            {tableNumber === 1 ? (
              data?.length > 0 ? (
                <>
                  <div className="table-container-v4">
                    <div className="pagination-buttons-v4">
                      <Pagination_2
                        filterDataInput={pagination}
                        setFilterDataInput={setPagination}
                        showNext={nextButton1}
                      />
                    </div>
                    <table className="data-table-v4">
                      <thead>
                        <tr>
                          <th>S.NO.</th>
                          <th>Event ID</th>
                          <th>Event Name</th>
                          <th>Count</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((val, key) => (
                          <tr key={key + 1}>
                            <td className="text-muted-v4">
                              {pagination.page * pagination.limit + (key + 1)}
                            </td>
                            <td className="text-mono-v4">
                              {val?._id?.event_id || "—"}
                            </td>
                            <td className="text-link-v4">
                              {eventCodeMap[val?._id.event_id] || "Unknown Event"}
                            </td>
                            <td className="amount-v4">
                              {val?.uniqueEventCount || 0}
                            </td>
                            <td>
                              <button
                                className="btn-action-table-v4 btn-sm-v4"
                                onClick={() => getEventDetails(val)}
                              >
                                View Details
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                </>
              ) : (
                <div className="empty-state-v4">
                  <div className="empty-icon-v4">📊</div>
                  <h3>No Event Data Found</h3>
                  <p>Select a date range to view event statistics</p>
                </div>
              )
            ) : (
              eventDetails?.length > 0 ? (
                <>
                  <div className="admin-header-v4" style={{ marginBottom: "24px", padding: "16px 24px" }}>
                    <h3 style={{ fontSize: "18px", margin: 0 }}>
                      Event Details for: <span style={{ color: "var(--primary-color)" }}>{eventCodeMap[eventid] || eventid}</span>
                      <span style={{ fontSize: "14px", color: "var(--text-muted)", marginLeft: "16px" }}>
                        (ID: {eventid})
                      </span>
                    </h3>
                    <div className="pagination-info-v4">
                      <span>Total Records: {eventDetails.length}</span>
                    </div>
                  </div>

                  <div className="table-container-v4">
                    <div className="pagination-buttons-v4">
                      <Pagination_2
                        filterDataInput={detailsPagination}
                        setFilterDataInput={setDetailsPagination}
                        showNext={nextButton}
                      />
                    </div>
                    <table className="data-table-v4">
                      <thead>
                        <tr>
                          <th>S.NO.</th>
                          <th>Event ID</th>
                          <th>Event Name</th>
                          <th>User ID</th>
                          <th>Email</th>
                          <th>Phone Number</th>
                          <th>Created At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {eventDetails?.map((val, key) => (
                          <tr key={key + 1}>
                            <td className="text-muted-v4">
                              {detailsPagination.page * detailsPagination.limit + (key + 1)}
                            </td>
                            <td className="text-mono-v4">
                              {val?.event_id || "—"}
                            </td>
                            <td>
                              <span className="earning-badge-v4 type-3">
                                {eventCodeMap[val?.event_id] || "Unknown"}
                              </span>
                            </td>
                            <td
                              className="text-link-v4"
                              onClick={() => window.open(`/users/transaction/${val.user_id}`)}
                              style={{ cursor: "pointer" }}
                            >
                              {val?.user_id || "—"}
                            </td>
                            <td className="text-mono-v4">
                              {val?.user_email || "—"}
                            </td>
                            <td className="text-mono-v4">
                              {val?.user_number || "—"}
                            </td>
                            <td className="text-muted-v4">
                              {val?.createdAt ?
                                moment(val?.createdAt).format("DD/MM/YY, h:mm:ss a") :
                                "—"
                              }
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                </>
              ) : (
                <div className="empty-state-v4">
                  <div className="empty-icon-v4">📄</div>
                  <h3>No Event Details Found</h3>
                  <p>No user records found for this event in the selected date range</p>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="loader-container-v4">
            <img src={loader} alt="Loading..." className="loader-image-v4" />
          </div>
        )}
      </div>
    </>
  );
};

export default UserEventLogs;